import * as yup from 'yup'

import { pageNum, pageSize, sortDirection, requiredString, requiredNumber } from '../../yup/schemas.js'

import { TRANSACTION_SORT_BY } from '../../constants.js'

export const recruiterSchema = yup.object({
  id: requiredString.uuid(),
  amount: requiredNumber,
  remaining: requiredNumber,
  description: requiredString
}).objectRequired()

const getTransactionListQueryParamsSchema = yup.object({
  pageNum,
  pageSize,
  sortBy: yup.string().oneOf(TRANSACTION_SORT_BY),
  sortDirection
}).objectRequired().allFieldsOptional()

const getTransactionListQueryParamsSchemas = { front: getTransactionListQueryParamsSchema, back: getTransactionListQueryParamsSchema }

export default {
  getTransactionListQueryParams: getTransactionListQueryParamsSchemas
}
